/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable no-unused-vars */
import {IconProps} from '../types/types';
import useIconColor from './useIconColor';
import useIconSize from './useIconSize';

interface IconDLS {
  iconSize: number;
  iconColor: string;
}

/**
 * Defines the useIconDLS hook which returns the icon color and size based
 * on the provided default values, if any.
 *
 * ```typescript
 *   import {useIconDLS} from '@ion/dls/src/icons/useIconDLS';
 *
 *   export const Icon = (props: IconProps) => {
 *     const {iconSize, iconColor} = useIconDLS(props);
 *     return (
 *       <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
 *         <path d='M10.484 18a1.313 1.313 0 100-2.625 1.313 1.313 0 000 2.625z'
 *          fill={iconColor}
 *          />
 *       </svg>
 *     );
 *   };
 *
 * ```
 */
export const useIconDLS = ({size, color}: IconProps): IconDLS => {
  const iconSize  = useIconSize(size);
  const iconColor = useIconColor(color);
  return {iconSize, iconColor};
};
export default useIconDLS;
